<template>
  <div class="ess-element-wrap">
    <div class="ess-line" :class="get_line_class(combinedMeter.data ? combinedMeter.data.p_total : null)"></div>
    <div class="ess-element">
      <div class="ess-element__header meter">
        <img src="@/assets/images/topo/ic_meter.png" width="24" alt="">
        <span class="ess-element__name"  :title="combinedMeter.uuid">{{ combinedMeter.meterName || '--' }}</span>
      </div>
      <div class="ess-element__body">
        <div class="ess-element__info">
          <span class="ess-element__text"  :title="$str.getKey('站级监控/总有功功率')"><abbr>{{$str.getKey('数据可视化/功率')}}：</abbr><b>{{ combinedMeter.data ?
              combinedMeter.data.p_total : '--'
          }}</b>kW</span>
        </div>
        <div class="ess-element__info">
          <span class="ess-element__text"  :title="$str.getKey('站级监控/AB线电压')"> <abbr>{{$str.getKey('数据可视化/电压')}}：</abbr><b>{{ combinedMeter.data ?
              combinedMeter.data.u_a : '--'
          }}</b>V</span>
        </div>
        <div class="ess-element__info">
          <span class="ess-element__text"  :title="$str.getKey('站级监控/A相电流')"> <abbr>{{$str.getKey('数据可视化/电流')}}：</abbr><b>{{ combinedMeter.data ?
              combinedMeter.data.i_a : '--'
          }}</b>A</span>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
const $str = window.$str
export default {
  setup() {
    return {
      $str
    }
  },
  props: {
    combinedMeter: {
      type: Object,
      default: function () {
        return {
          data: {}
        }
      }
    }
  },


  methods: {
    get_line_class(p) {
      // if (Math.abs(p) < 1) {
      //   return ''
      // }
      // charge
      if (p > 0) {
        return 'down'
      }
      // discharge
      if (p < 0) {
        return 'up'
      }
      return ''
    }
  }
}
</script>


<style>
.ess-element__text abbr {
  text-decoration: none;
}
</style>
